import React, { useEffect, useState } from "react";
import './MessageModal.css'

const MessageModal = ({ show, onClose, onSave, isMessage, messageContent }) => {
    const [message, setMessage] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [isCommentAvailable, setIsCommentAvailable] = useState(true);
    const handleOnSave = (message) => {
        onSave(message);
        setMessage("");
    }
    useEffect(() => {
        if(message.trim() !== "") {
            setIsCommentAvailable(false);
        }
    },[message]);

    if (!show) return null;
    return (
        // !isMessage ? 
        // <div className="custom-modal-overlay">
        //     <div className="custom-modal-content">
        //         <h2>Enter Message</h2>
        //         <textarea
        //             value={message}
        //             onChange={(e) => setMessage(e.target.value)}
        //             placeholder="Enter your message..."
        //             className="custom-textarea"
        //         />
        //         <div className="custom-modal-buttons">
        //             <button className="custom-save-btn" onClick={() => onSave(message)}>Save</button>
        //             <button className="custom-cancel-btn" onClick={onClose}>Cancel</button>
        //         </div>
        //     </div>
        // </div> 
        // :
        <div className="custom-modal-overlay">
        <div className="custom-modal-content">
            <h4 className="mb-4">Add Comment</h4>
            {messageContent?.filter((item) => item.comment.trim() !== "").map((item, index) => (
                <div key={index} className="message-item">
                    <p className="mb-0" style={{fontWeight: '600'}}> {item.comment}</p>
                    <p className="mb-0">
                        {new Date(item.created_at).toLocaleString('en-IN', {
                            timeZone: 'Asia/Kolkata',
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: true
                        })}
                        </p>
                </div>
            ))}
            <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter your comment..."
                className="custom-textarea"
            />
            <div className="custom-modal-buttons">
                <button className="custom-cancel-btn" onClick={onClose}>Cancel</button>
                <button className="custom-save-btn" disabled={isCommentAvailable} onClick={() => handleOnSave(message)}>Add</button>
            </div>
        </div>
    </div> 
    );
};

export default MessageModal;
